import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const ServiceCard = ({ service, index }) => {
  const { getService, t } = useLanguage();
  const localizedService = getService(service);
  const IconComponent = Icons[service.icon] || Icons.Eye;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: Math.min(index * 0.05, 0.4) }}
      className="bg-white p-7 md:p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-xl hover:border-gray-200 hover:-translate-y-1 transition-all duration-300 group flex flex-col h-full"
    >
      <div className="w-14 h-14 bg-[#F4F9FF] text-clinical rounded-xl flex items-center justify-center mb-5 group-hover:bg-clinical group-hover:text-white group-hover:scale-105 transition-all duration-300 shadow-sm">
        <IconComponent size={28} strokeWidth={1.75} />
      </div>

      {localizedService.category && (
        <span className="text-[11px] font-bold text-teal uppercase tracking-widest block mb-2">
          {localizedService.category}
        </span>
      )}

      <h3 className="text-lg md:text-xl font-bold text-navy mb-3 leading-snug">
        {localizedService.name}
      </h3>

      <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-grow">
        {localizedService.description}
      </p>

      <div className="flex items-center justify-between pt-4 border-t border-gray-100 mt-auto">
        <Link 
          to={`/appointment?service=${encodeURIComponent(service.id)}`}
          state={{ service: service.id }}
          className="text-sm font-semibold text-clinical hover:text-navy transition-colors flex items-center gap-1 group/link"
        >
          <span>{t('servicesSection.bookConsultation')}</span>
          <span className="group-hover/link:translate-x-1 transition-transform">&rarr;</span>
        </Link>
        <Link 
          to="/contact" 
          className="text-xs font-medium text-gray-400 hover:text-navy transition-colors"
        >
          {t('servicesSection.enquire')}
        </Link>
      </div>
    </motion.div>
  );
};

export default ServiceCard;
